import {useCallback, useContext, useEffect, useState} from "react";
import {MainLayout} from "../components/layouts/MainLayout";
import NewMovieGrid from "../components/movie-grid/NewMovieGrid";
import Button from "../components/buttons/Button";
import ButtonLink from "../components/buttons/ButtonLink";
import {ButtonSize, ButtonVariant} from "../types/button";
import {AppMainStateContext} from "../contexts/AppMainStateContext.tsx";
import {useChannelsService} from "../hooks/useChannelsService.tsx";
import {IChannel} from "../interfaces/IChannel.ts";
import {ChevronRightIcon} from "@heroicons/react/24/outline";
import {IPromotionBanner} from "../interfaces/templates/bannerHome/IPromotionBanner.ts";
import apiNet from "../newApi/apiNet.ts";
import PromotionBannerTemplate1 from "../components/account/marketing/banner/PromotionBannerTemplate1.tsx";
import UtilsHelper from "../helpers/utilsHelper.ts";
import {IPopularChannel} from "../interfaces/IPopularChannel.ts";
import {BellIcon, HeartIcon} from "@heroicons/react/24/solid";
import {Link} from "react-router-dom";
// import Echo from "../services/echo.ts";

export default function NewHome() {
    const {
        channels,
        recommendedChannels,
        getChannels,
        updateEpgListToActualTime,
        getRecommendedChannels,
    } = useChannelsService();
    const {
        appStates,
        setIsCookiesAgreed,
        isModalOpen,
        openModal
    } = useContext(AppMainStateContext);
    const [popularChannels, setPopularChannels] = useState<Array<IChannel>>([]);
    const [banner, setBanner] = useState<IPromotionBanner | null>(null);
    const [opacityBanner, setOpacityBanner] = useState(1);

    const getHomeVM = useCallback(
        async () => {
            if (popularChannels.length === 0 && channels.length > 0) {
                const response = await apiNet.getHomeVM();
                setBanner(response.data.banner);
                const popularChannelListTemp = createPopularChannelList(response.data.popularChannels);
                setPopularChannels([...popularChannelListTemp]);
            }
        }, [channels]);

    const createPopularChannelList = (popularChannel: IPopularChannel[]): IChannel[] => {
        const popularChannelListTemp: IChannel[] = [];
        popularChannel.forEach(item => {
            const channelTemp = channels.find(x => x.ch_id === item.channelId)
            if (channelTemp)
                popularChannelListTemp.push(channelTemp);
        });
        if (popularChannelListTemp.length < 20) {
            for (let i = 0; i < 20; i++) {
                const channelTemp = channels[i];
                if (!popularChannelListTemp.includes(channelTemp))
                    popularChannelListTemp.push(channelTemp);
            }
        }
        return popularChannelListTemp;
    }

    useEffect(() => {
        getChannels();
    }, [getChannels]);

    useEffect(() => {
        (async () => {
            await getHomeVM();
        })();
    }, [getHomeVM]);

    useEffect(() => {
        if (appStates.isCookiesAgreed) getRecommendedChannels();
        let interval: number;
        if (!isModalOpen) {
            interval = setInterval(() => {
                updateEpgListToActualTime(channels);
            }, 5000);
        }

        return () => {
            clearInterval(interval);
        };
    }, [appStates.isCookiesAgreed, channels, isModalOpen]);

    // useEffect(() => {
    //     if (import.meta.env.VITE_BACKEND_TYPE === "php") {
    //         // --- 1. Subskrypcja Kanału Publicznego ---
    //
    //         // Zmień 'status-updates' na faktyczną nazwę Twojego kanału
    //         const channel = Echo.private(`App.Models.User.72013aef-1708-45e6-a7fb-faac750bbbb6`);
    //
    //         // --- 2. Nasłuchiwanie na konkretne zdarzenie ---
    //
    //         channel.listen('.UpdateStatusEvent', (e) => {
    //             console.log("Otrzymano zdarzenie:", e);
    //         });
    //
    //         channel.listen('.UpdateStatusEvent1', (e) => {
    //             console.log("Otrzymano zdarzenie:", e);
    //         });
    //
    //         channel.listen('.UpdateStatusEven2', (e) => {
    //             console.log("Otrzymano zdarzenie:", e);
    //         });
    //
    //         channel.listen('.UpdateStatusEvent4', (e) => {
    //             console.log("Otrzymano zdarzenie:", e);
    //         });
    //     }
    //
    //     // --- 3. Funkcja czyszcząca (Unsubscribe) ---
    //     // Kluczowe dla uniknięcia wycieków pamięci i wielokrotnych subskrypcji
    //     return () => {
    //         Echo.leave('status-updates');
    //         // Jeśli używasz prywatnych kanałów, uzyj: Echo.leave('private-channel-name');
    //     };
    //
    // }, [])

    const handleChangeCookieAgreedClick = () => {
        setIsCookiesAgreed("not set");
        openModal();
    };

    const handleScroll = useCallback(() => {
        const offset = 75;
        const opacityRange = 300;
        const bodyElem = document.querySelector("html");
        // const bodyElem = document.getElementById("main-content");
        let scrollTop = 0;
        if (bodyElem)
            scrollTop = window.scrollY;
        if (scrollTop >= offset) {
            const opacity = 1 - ((scrollTop - offset) / opacityRange);
            setOpacityBanner(opacity > 0.1 ? opacity : 0.1);
        }
    }, []);


    useEffect(() => {
        UtilsHelper.changeWindowDocumentTitle("Strona główna");
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);

    return (
        <MainLayout contentPadding="md:px-4 pr-0 pb-4">
            {banner === null &&
                <div className={"w-full h-[33rem] md:h-[30rem] shrink-0 block"}/>
            }

            {banner && banner.templateId &&
                <PromotionBannerTemplate1 opacity={opacityBanner} bannerData={banner}/>}

            {/*<div*/}
            {/*    className={"fixed flex gap-5 z-10 right-4 top-[4.5rem] md:top-6 md:right-6 bg-neutral-600/50 border border-neutral-500 py-3 px-4 rounded-full"}>*/}
            {/*    <Link to={"/konto/ulubione"}><HeartIcon className={"w-8 h-8"}/></Link>*/}
            {/*    <button><BellIcon className={"w-8 h-8"}/></button>*/}
            {/*</div>*/}

            <div className="flex flex-col w-full">
                <div className={"pl-4 md:pl-0 md:pt-36 md:mt-0 pb-4 z-10"}>
                    <h2 className="text-base">Polecane dla Ciebie</h2>
                </div>

                {appStates.isCookiesAgreed === true ?
                    <NewMovieGrid
                        channels={
                            recommendedChannels.length > 0
                                ? recommendedChannels
                                : channels.filter((x) => x.enabled).slice(0, 4)
                        }
                        skeletonLoadingItemQuantity={5}
                    />
                    :
                    <div className={"flex text-sm z-10"}>
                        <div
                            className={`bg-neutral-900 p-5 space-y-3 mr-4 h-60 rounded md:max-w-96 ${!appStates.isCookiesAgreed && "h-auto"} ${appStates.isCookiesAgreed === "not set" && "h-auto"}`}>
                            <p className={"text-base font-medium"}>
                                Wymagana zgoda na pliki cookie
                            </p>
                            <p className={"text-neutral-400"}>
                                W celu zapewnienia personalizacji, wymagamy zgody na
                                opcjonalne pliki cookie.
                            </p>
                            <Button
                                variant={ButtonVariant.PRIMARY}
                                size={ButtonSize.SMALL}
                                onClick={() => handleChangeCookieAgreedClick()}
                                className={"ring-offset-neutral-900"}
                            >
                                Zmień ustawienia
                            </Button>
                        </div>
                    </div>
                }
                <div className={"pl-4 md:pl-0 flex justify-between items-center md:pr-4 py-4 z-10"}>
                    <h2 className="text-base">Obecnie Popularne Kanały</h2>
                    <ButtonLink
                        to={"kanaly-tv"}
                        variant={ButtonVariant.SECONDARY}
                    >
                        <>
                            <span className={"hidden sm:inline-block"}>Pokaż wszystkie</span>
                            <ChevronRightIcon className={"h-7 w-7 sm:hidden stroke-[2.5]"}/>
                        </>
                    </ButtonLink>
                </div>
                <NewMovieGrid
                    channels={popularChannels.filter(x => x.enabled)}
                    skeletonLoadingItemQuantity={5}
                />
            </div>
            {/* <Footer className={"mt-8 z-10"} /> */}
        </MainLayout>
    );
}